import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LanguagesTranslateFuseModule } from '../../languages-translate/languages-translate-fuse.module';
import { OnboardingBrand } from '../ai-exam-onboarding-progress.util';

/**
 * Shell visuel unifié pour l'onboarding FlashLevel et LILATE IA.
 * Logo centré, barre de progression linéaire et carte blanche (maquettes HTML).
 */
@Component({
    selector: 'lib-ai-exam-onboarding-shell',
    standalone: true,
    imports: [CommonModule, LanguagesTranslateFuseModule],
    templateUrl: './AI-exam-onboarding-shell.component.html',
    styleUrls: ['./AI-exam-onboarding-shell.component.scss'],
})
export class AIExamOnboardingShellComponent {
    @Input() brand: OnboardingBrand = 'flashlevel';
    @Input() progressPercent = 0;
    @Input() progressLabel = '';
    @Input() showProgress = true;
    @Input() wideCard = false;

    readonly flashlevelLogoUrl = 'assets/images/brand/logo-FlashLevel-bg.png';
    readonly lilateLogoUrl = 'assets/images/lilate_short_color.svg';
}
